// extracted by mini-css-extract-plugin
export var indeterminate = "_54-6";
export var md = "_54-5";
export var semantic = "_54-7";
export var sm = "_54-4";
export var text = "_54-8";
export var toggleControl = "_54-0";
export var toggleInput = "_54-1";
export var toggleSwitch = "_54-2";
export var xs = "_54-3";